import { BulkUploadType, MEDIA_CONFIG, getFileExtension } from '../../constants/mediaConfig';
import { getMaxMediaSizeBytes, getMaxMediaSizeMb } from '../../constants/uploadLimits';

import { FileValidation } from './types';

import { Platform } from '@/features/pages';

export const validateMediaFile = (
  file: File,
  mediaType: BulkUploadType,
  platform: Platform
): FileValidation => {
  const config = MEDIA_CONFIG[mediaType];
  const extension = getFileExtension(file.name);

  if (!extension || !config.extensions.includes(extension)) {
    return {
      ok: false,
      kind: 'format',
      message: `Формат не поддерживается. Допустимые: ${config.allowedLabel}`,
      badge: 'Формат',
    };
  }

  const maxSize = getMaxMediaSizeBytes(platform, mediaType);
  if (file.size > maxSize) {
    const limitMb = getMaxMediaSizeMb(platform, mediaType);
    return {
      ok: false,
      kind: 'size',
      message: `Превышен лимит ${limitMb} МБ`,
      badge: 'Размер',
    };
  }

  return { ok: true };
};
